import { z } from 'zod'

export function apiResponseSchema<TResult = any>(schema: z.ZodType<TResult>) {
  return z.object({
    /** 回應碼 */
    status: z.number(),
    /** 回應訊息 */
    message: z.string(),
    /** 成功否 */
    success: z.boolean(),
    /** 總筆數 */
    total: z.number().nullable(),
    /** 資料清單 */
    data: schema
  })
}

export type ApiResponse<T> = z.infer<ReturnType<typeof apiResponseSchema<T>>>
